"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonalCloudStorageType = void 0;
var PersonalCloudStorageType;
(function (PersonalCloudStorageType) {
    PersonalCloudStorageType["Dropbox"] = "Dropbox";
    PersonalCloudStorageType["Box"] = "Box";
    PersonalCloudStorageType["BoxDrive"] = "BoxDrive";
    PersonalCloudStorageType["GoogleBackupAndSync"] = "GoogleBackupAndSync";
    PersonalCloudStorageType["GoogleDrive"] = "GoogleDrive";
    PersonalCloudStorageType["GoogleFileStream"] = "GoogleFileStream";
    PersonalCloudStorageType["Icloud"] = "ICloud";
    PersonalCloudStorageType["Onedrive"] = "OneDrive";
    PersonalCloudStorageType["GoogleDriveForDesktop"] = "GoogleDriveForDesktop";
})(PersonalCloudStorageType = exports.PersonalCloudStorageType || (exports.PersonalCloudStorageType = {}));
